import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Benjamin/Desktop/repos/gatsby-templates/chronoblog-site/node_modules/gatsby-theme-chronoblog/src/components/page/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AuthorBanner = makeShortcode("AuthorBanner");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AuthorBanner mdxType="AuthorBanner" />
    <h2 {...{
      "id": "skills"
    }}>{`Skills`}</h2>
    <p><strong parentName="p">{`Programming:`}</strong>{` JavaScript, HTML5/CSS, C#, GatsbyJS, node.js, Microservices, REST API Development & Consumption, Refactoring, Scripting, Technical Writing & Documentation`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Tooling:`}</strong>{` Git/GitHub/Version Control, Chrome Developer Tools, Linux & Unix-like Operating Systems`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Methodologies, Techniques & Paradigms:`}</strong>{` Agile, Scrum, Kanban, Waterfall, Object-Oriented Programming`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Soft Skills:`}</strong>{` Business & Professional Communication, Servant Leadership, Teamwork, Stakeholder Management & Engagement`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Music & Audio:`}</strong>{` Sound Design, Music & Podcast Production, Guitar, Bass, Synthesizers, Drum Machines, Ableton Live`}</p>
    <h2 {...{
      "id": "experience"
    }}>{`Experience`}</h2>
    <p><strong parentName="p">{`Software Engineer, DePaul University`}</strong>{` (Jan 2020 - present)`}</p>
    <ul>
      <li parentName="ul">{`Develops data visualizations with vanilla JavaScript and D3.js, powered by Python backends built with Flask and Django.`}</li>
      <li parentName="ul">{`Designed and implemented a mobile layout for a resource-intensive web app that had 8,000+ page views within the first 24 hours of site launch after being featured in the Atlantic. Contributed maintenance and optimization to the core application at other stages in the product lifecycle.`}</li>
      <li parentName="ul">{`Maintains and refactors inherited code, optimizing for performance, readability, reusability, and modularity.`}</li>
      <li parentName="ul">{`Spearheads efforts to improve documentation across projects and facilitates project management using Kanban boards and GitHub issues.`}</li>
      <li parentName="ul">{`Collaborates with a group of interdisciplinary project stakeholders through a grant-funded partnership with the National Science Foundation, University of Chicago, & DePaul University.`}</li>
    </ul>
    <p><strong parentName="p">{`Research Assistant (Software Engineering), DePaul University`}</strong>{` (Jul 2019 – Jan 2020)`}</p>
    <ul>
      <li parentName="ul">{`Began the above position as a research assistant/software engineer. My success in this role led to employment as a full-time staff member. `}</li>
    </ul>
    <p><strong parentName="p">{`Transfer Student Mentor, DePaul University`}</strong>{` (Oct 2018 – Jun 2019)`}</p>
    <ul>
      <li parentName="ul">{`Mentored a diverse group of 50+ transfer students pursuing undergraduate STEM degrees and provided outreach weekly via email and phone contact to improve campus engagement.`}</li>
      <li parentName="ul">{`Demonstrated leadership and team-building skills by co-leading a team of 8 other undergrad mentors.`}</li>
      <li parentName="ul">{`Implemented a Slack channel to improve communication. On-boarded and trained new coworkers.`}</li>
    </ul>
    <h2 {...{
      "id": "education"
    }}>{`Education`}</h2>
    <p><strong parentName="p">{`BS Information Technology, DePaul University`}</strong>{` (2015 - 2019)`}</p>
    <ul>
      <li parentName="ul">{`Studied full-stack web development, object-oriented programming, scripting, databases, systems design, data structures, discrete mathematics, operating systems, information security, interaction design, business ethics, project management, content management systems, musical improvisation, and audio for digital media.`}</li>
      <li parentName="ul">{`Gained academic experience with/exposure to JavaScript, GatsbyJS, GraphQL, Express.js, Node.js, jQuery, Linux, C, Python, assembly languages, Java, Ruby on Rails, SQLite3, WordPress, Drupal 8, and other technologies.`}</li>
      <li parentName="ul">{`Participated in service-based learning projects to build websites and practice agile methodologies while interfacing with real clients in a volunteer capacity. `}</li>
    </ul>
    <h2 {...{
      "id": "awards"
    }}>{`Awards`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Summa Cum Laude`}</strong>{`, DePaul University (Fall 2019).`}</li>
      <li parentName="ul"><strong parentName="li">{`Dean's List`}</strong>{`, DePaul University (2015-2019). Received every quarter from enrollment to graduation.`}</li>
    </ul>
    {
      /*  
      Projects
      --------
      ***Chakra Advisors Website Upgrade*** (Jan 2019 – Jun 2019)
      - Delivered a Drupal 8 website to a remote financial services client located in the San Francisco Bay Area, working as both a developer and project lead to an agile team of 5. 
      - Resolved security and stability issues by rebuilding the client's existing Drupal 7 website from the ground up in a collaborative, cloud-based Linux development server.
      - Facilitated weekly remote client meetings for sprint review and further requirements gathering.  
      - Led the scrum team through one-week sprint cycles, facilitating all Agile ceremonies and guiding through each milestone.
      - Maintained a Slack channel so that the team could communicate clearly and frequently.
      - Adapted to changing project needs by implementing a Kanban workflow and developing a hybrid "scrumban" approach. This allowed us to streamline our development process after realizing that the overhead from sprint cycles was harming the project.
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      